import { GET_PRODUCT_TABLE_DATA } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_PRODUCT_TABLE_DATA:
            return action.payload;
        default:
            return state;
    }
}